import {
  PAYMENT_REASON_FILTER,
  PAYMENT_REASON_LIST,
  PAYMENT_REASON_CHECK,
  PAYMENT_REASON_CHECK_ALL
} from 'actions/paymentReason';

const initState = {
  searchFilter: {
    name: '',
    store: '',
    reason: '',
    type: 'ALL',
    page: 1,
    pageRow: 15,
    totalCount: 0
  },
  paymentReasonList: []
};

const check = (list, payload) => {
  const $header = $('.rt-table .rt-thead .rt-tr .rt-th');
  const $checkBoxes = $header.eq(0).find('input:checkbox:not([disabled])');
  let checkedCount = 0;
  const result = list.map((item, i) => {
    if (payload.index === i) {
      if (payload.checked) {
        checkedCount += 1;
      }
      return { ...item, isChecked: payload.checked };
    }
    if (item.isChecked) {
      checkedCount += 1;
    }
    return item;
  });

  if (checkedCount === list.length) {
    $checkBoxes.prop('checked', true);
  } else {
    $checkBoxes.prop('checked', false);
  }

  return result;
};

const withChecked = (room = []) => {
  if (Array.isArray(room) && room.length) {
    return room.map((e) => ({ ...e, isChecked: false }));
  }
  return [];
};

function paymentReason(state = initState, action) {
  const { payload } = action;
  const room = state.paymentReasonList && [...state.paymentReasonList];
  switch (action.type) {
    case `${PAYMENT_REASON_LIST}_FULFILLED`:
      return {
        ...state,
        searchFilter: {
          ...state.searchFilter,
          totalCount: payload.paging.totalcount
        },
        paymentReasonList: withChecked(payload.room),
        pending: false
      };
    case `${PAYMENT_REASON_LIST}_PENDING`:
      return {
        ...state,
        paymentReasonList: payload,
        pending: true
      };
    case `${PAYMENT_REASON_LIST}_REJECTED`:
      return {
        ...state,
        paymentReasonList: payload,
        pending: false
      };
    case PAYMENT_REASON_FILTER:
      return {
        ...state,
        searchFilter: {
          ...state.searchFilter,
          ...payload
        }
      };
    case `${PAYMENT_REASON_FILTER}_CLEAR`:
      return {
        ...state,
        ...{ searchFilter: payload }
      };
    case `${PAYMENT_REASON_CHECK}`:
      return {
        ...state,
        paymentReasonList: check(room, payload)
      };
    case `${PAYMENT_REASON_CHECK_ALL}`:
      return {
        ...state,
        paymentReasonList: room.map((item) => ({ ...item, isChecked: payload }))
      };
    default:
      return state;
  }
}

export default paymentReason;
